import React, { useEffect } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { getQueryParams } from '../../../helpers/survey/survey';

import SurveyStore from '../../../store/models/SurveyModel';
import { observer } from 'mobx-react';

import Form from "react-jsonschema-form";
import Loading from "../../reusable/Loading/Loading";
import DefaultView from "../../reusable/DefaultView/DefaultView";
import RandonOptionEnumFieldComponent from "../../../helpers/rjsfSortRandomEnumValues/SortRandomEnumValues";
import SortRandomEnumFieldRadioButton from "../../../helpers/rjsfSortRandomEnumValues/SortRandomEnumValuesRadioButton";
import StarRatingOptionEnumFieldComponent from "../../../helpers/rjsfSortRandomEnumValues/StarRatingEnumValues";
import BooleanFieldComponent from "../../../helpers/rjsfSortRandomEnumValues/BooleanField";

import _sc from '../../../store/constants/__survey';

import ReactJsonSchemaHelper from '../../../helpers/app/jschema_form';

import __envs from '../../../store/constants/__envs';
import _ from 'lodash';
import BuyTag from '../../reusable/AdditionalStacks/BuyTag/BuyTag';

const SurveyForm = observer(function (props: any) {
  const params: any = useParams();
  const { slug, countryCode } = params;
  const location = useLocation();
  const history = useHistory();
  let customFields = {
    SortRandomField: RandonOptionEnumFieldComponent,
    SortRandomFieldRadioButton: SortRandomEnumFieldRadioButton,
    StarRatingField: StarRatingOptionEnumFieldComponent,
    checkbox: BooleanFieldComponent
  };
  let queryStringsParams = getQueryParams(location.search);

  // cdm - get the data, set the userId
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    queryStringsParams = getQueryParams(location.search);
    initSurvey();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug, countryCode, queryStringsParams.userId, queryStringsParams.productId, queryStringsParams.serviceKind]);


  const initSurvey = async () => {
    const { userId, productId, companyProcessId, serviceKind } = queryStringsParams;
    SurveyStore.setProductId(productId);
    if (serviceKind !== undefined) {
      SurveyStore.setServiceKind(serviceKind);
    }
    await SurveyStore.getSurvey(slug, countryCode, userId, companyProcessId);
  }


  const onChange = (event: any) => {
    const { formData } = event;
    const { userId } = queryStringsParams;
    SurveyStore.setFormData(formData);
    if (userId !== 'anonymous' && userId?.toString().match(__envs.emailRegex)) {
      SurveyStore.loadingButton = true;
      debounce(formData);
    }
  }
  const debounceRef = React.useRef(
    _.debounce((formData) => {
      SurveyStore.updateSurveyAnswer(formData, location, 0);
    }, __envs.debounceTimeApiRequest)
  );

  const debounce = (formData: any) => {
    debounceRef.current(formData);
  }

  async function submitSurvey(data: any) {
    //Check if there is a surveyAnswerStored
    if (SurveyStore.surveyAnswerStored) {
      //Update the stored surveyAnswer as completed.
      SurveyStore.updateSurveyAnswer(data.formData, location, 1);
    } else {
      //Saving as usual.
      SurveyStore.saveSurveyAnswer(data.formData, location);
    }
    history.push('/');
  }

  const additionalStacks = {
    'comprar-tag': (
      <BuyTag />
    )
  }

  return (
    <div>
      {
        additionalStacks[slug] && (
          additionalStacks[slug]
        )
      }
      {
        SurveyStore.status === _sc.appStatus.surveyIsLoaded &&
        <Form
          schema={SurveyStore.survey.jsonSchema}
          uiSchema={SurveyStore.survey.uiSchema}
          showErrorList={false}
          formData={SurveyStore.survey.formData ? SurveyStore.survey.formData : {}}
          onSubmit={submitSurvey}
          transformErrors={ReactJsonSchemaHelper.transformErrorsAdapter(SurveyStore.survey.extraErrors)}
          fields={customFields}
          onChange={onChange}
          >
          <button id="submit-survey-button" type="submit" className="btn btn-secondary" disabled={SurveyStore.loadingButton}>
            {SurveyStore.survey.answerSchema?.sendButtonText || "ENVIAR"}
          </button>
        </Form>
      }
      {
        SurveyStore.status === _sc.appStatus.loading &&
        <Loading />
      }
      {
        SurveyStore.status === _sc.appStatus.initial &&
        <DefaultView />
      }
    </div>
  )

});

export default SurveyForm;
